module.exports = __webpack_public_path__ + "static/media/icon_remove.16cef1a8.svg";